/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ParentInputs */

const de__field_parent = /** @type {(inputs: _Field_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergeordnete Kooperationspartnereinheit`)
};

/**

* @param {_Field_ParentInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_parent = /** @type {((inputs?: _Field_ParentInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ParentInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_parent(inputs)
});